export const DEFAULT_TIME = 0;
export const HIGHEST_SINGLE_DIGIT = 9;
